var installedModules = {};
var moduleToHandlerMapping = {
	13732: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(96540); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	1995: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(74848); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	81924: {
		getter: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	10865: {
		getter: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(6417), __webpack_require__.e(6715), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(86715); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	33224: {
		getter: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(1106), __webpack_require__.e(5547)]).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	59914: {
		getter: function() { return Promise.all([__webpack_require__.e(6417), __webpack_require__.e(8122), __webpack_require__.e(6066)]).then(function() { return function() { return __webpack_require__(28133); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	38006: {
		getter: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	44178: {
		getter: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__(14953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	18712: {
		getter: function() { return __webpack_require__.e(2140).then(function() { return function() { return __webpack_require__(29759); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	57733: {
		getter: function() { return __webpack_require__.e(8501).then(function() { return function() { return __webpack_require__(30882); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	57070: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	8122: {
		getter: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(3732)]).then(function() { return function() { return __webpack_require__(40961); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	49252: {
		getter: function() { return Promise.all([__webpack_require__.e(4036), __webpack_require__.e(9522), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(79522); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.30",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-react-utils",
	},
	75016: {
		getter: function() { return Promise.all([__webpack_require__.e(8486), __webpack_require__.e(4560)]).then(function() { return function() { return __webpack_require__(62179); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.102",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-auth-react",
	},
	35464: {
		getter: function() { return __webpack_require__.e(1106).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	93780: {
		getter: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	57743: {
		getter: function() { return __webpack_require__.e(6682).then(function() { return function() { return __webpack_require__(24301); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.107",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-auth-react",
	},
	74270: {
		getter: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__(14953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	}
};
var initialConsumes = [13732,1995,81924,10865,33224,59914,38006,44178,18712,57733,13732,57070,8122,1995,10865,49252,75016,35464,93780,57743,74270];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"636": [
		1995,
		10865,
		49252,
		75016,
		35464,
		93780
	],
	"1995": [
		1995
	],
	"3732": [
		13732
	],
	"4270": [
		74270
	],
	"5016": [
		75016
	],
	"5527": [
		81924,
		10865,
		33224,
		59914,
		38006,
		44178,
		18712,
		57733
	],
	"7743": [
		57743
	],
	"8122": [
		8122
	],
	"8792": [
		13732,
		57070,
		8122
	],
	"9252": [
		49252
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}